import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import 'flatpickr/dist/themes/light.css';

const INTERNAL_DATE_FORMAT = "Y-m-d";
const INTERNAL_TIME_FORMAT = "H:i";

const DATE_FORMAT = "m/d/Y";
const TIME_FORMAT = "h:i K";

const minDate = new Date();
minDate.setHours(0);
minDate.setMinutes(0);
minDate.setSeconds(0);
minDate.setMilliseconds(0);

export default class extends Controller {
    _getOptions() {
        const type = this.element.getAttribute("data-type");

        switch (type) {
            case "time":
                return {
                    enableTime: true,
                    noCalendar: true,

                    altFormat: TIME_FORMAT,
                };
            case "date":
                return {
                    altFormat: DATE_FORMAT,
                };

            default:
                return {
                    enableTime: true,

                    altFormat: `${DATE_FORMAT}, ${TIME_FORMAT}`,
                };
        }
    }

    _getFomat() {
        const type = this.element.getAttribute("data-type");

        switch (type) {
            case "time":
                return INTERNAL_TIME_FORMAT;
            case "date":
                return INTERNAL_DATE_FORMAT;

            default:
                return `${INTERNAL_DATE_FORMAT}\\T${INTERNAL_TIME_FORMAT}`;
        }
    }

    handleChange = (_arg1, _arg2, picker) => {
        this.element.dispatchEvent(new Event("change"));
    };

    connect() {
        const parentElement = this.element.parentElement;
        const flatpickr_field = parentElement.querySelector('.input');
        if (flatpickr_field != null) {
            flatpickr_field.remove();
        }
        flatpickr(this.element, {
            altInput: true,
            minuteIncrement: 1,
            onChange: this.handleChange,
            dateFormat: this._getFomat(),
            disableMobile: "true",
            ...this._getOptions(),
        });
    }
}